export const autoFeedbackSettingsActions = {
    AUTO_FEEDBACK_SETTINGS_PANEL_VISIBLE: 'AUTO_FEEDBACK_SETTINGS_PANEL_VISIBLE',
    AUTO_FEEDBACK_SETTINGS_SAVING: 'AUTO_FEEDBACK_SETTINGS_SAVING',
    AUTO_FEEDBACK_SETTINGS_STORE: 'AUTO_FEEDBACK_SETTINGS_STORE',
    AUTO_FEEDBACK_BLAST_MESSAGE_SENDING: 'AUTO_FEEDBACK_BLAST_MESSAGE_SENDING'
}
